module.exports = __webpack_public_path__ + "static/media/headshot.64f1b002.png";